import request from '@/utils/request'

const api = {
    Getcapacity: 'https://open.ys7.com/api/lapp/device/capacity', // 萤石云获取是否支持云台
    GetSFJInfoByCode: '/api/sfj/getSFJInfoByCode', // 优联施肥机参数获取
    SendMessageByCode: '/api/sfj/sendMessageByCode', // 设置优联施肥机通道模式
    ControlSFJByCode: '/api/sfj/controlSFJByCode', // 控制优联施肥机
    SetSFJParamByCode: '/api/sfj/setSFJParamByCode', // 设置优联施肥机参数
    GetSFJParamByCode: '/api/sfj/getSFJParamByCode', // 获取优联施肥机参数
    GetFarmMonitorStatus: '/api/farmMonitor/status', // 农场各类设备状态
    GetFarmMonitorDeviceDetail: '/api/farmMonitor/deviceDetail', // 农场异常设备详情
    Analyze4GOfflineReason: '/api/farmMonitor/analyze4GOfflineReason', // 分析4G设备离线原因
    RefreshFarmMonitorStatus: '/api/farmMonitor/refresh', // 重新查询农场各类设备状态
    GetLand: '/api/app/getLand', // 农场地块列表
    YieldFindAll: '/api/yield/findAll', // 目标产量列表
    FertilizerFindAll: '/api/fertilizer/findAll', // 肥料库
    CreateLandScheme: '/api/wfscheme/createLandScheme', // 生成水肥方案
    UpdateBase: '/api/wfscheme/updateBase', // 重新计算基肥
    UpdateTopdressing: '/api/wfscheme/updateTopdressing', // 重新计算追肥
    WfschemeSave: '/api/wfscheme/save', // 保存水肥方案
    GetMapFarm: '/api/map/getFarm', // 调度中心 GIS 数据
    GetMapFarmInfo: '/api/map/getFarmInfo', // 农场地图中心点
    GetMapDeviceNum: '/api/map/getDeviceNum', // 农场设备统计
    GetProjectIrrigation: '/api/project_new/getProjectIrrigation', // 地块详情
    GetDeviceInfo: '/api/map/getDeviceInfo',
    GetCDZDeviceInfo: '/api/map/getCDZDeviceInfo',
    GetMoisture: '/api/app/getMoisture',
    GetWeatherStationYL: '/api/app/getWeatherStationYL',
    GetCQInfo: '/api/cqapi/getCQInfo/',
    GetBZInfo: '/api/bzapi/getBZInfo/',
    GetSCDInfo: '/api/scdapi/getSCDInfo/',
    GetSFJInfo: '/api/sfj/getSFJInfo',
    GetUsers: '/api/map/getUsers',
    AddUser: '/api/app/addUser',
    AuthZUser: '/api/map/authZUser',
    RemoveUser: '/api/map/removeUser',
    GetFarmTree: '/api/map/getFarmTree',
    GetFarmById: '/api/app/getFarmById', // 农场阀门状态汇总
    GetGWs: '/api/app/getGWs',
    GetSoilMoistureLists: '/api/map/getSoilMoistureLists',
    GetWeatherStationLists: '/api/map/getWeatherStationLists',
    GetSporeDevices: '/api/map/getSporeDevices',
    GetInsecticidalLamps: '/api/map/getInsecticidalLamps',
    GetMonitors: '/api/map/getMonitors',
    GetPestMonitorPictures: '/api/map/getPestMonitorPictures',
    GetSFJs: '/api/map/getSFJs',
}

export function getcapacity(parameter) {
  return request({
    url: api.Getcapacity,
    method: 'get',
    params: parameter
  })
}

export function getSFJInfoByCode(parameter) {
  return request({
    url: api.GetSFJInfoByCode,
    method: 'get',
    params: parameter
  })
}

export function sendMessageByCode(parameter) {
  return request({
    url: api.SendMessageByCode,
    method: 'get',
    params: parameter
  })
}

export function controlSFJByCode(parameter) {
  return request({
    url: api.ControlSFJByCode,
    method: 'get',
    params: parameter
  })
}

export function setSFJParamByCode(parameter) {
  return request({
    url: api.SetSFJParamByCode,
    method: 'post',
    params: parameter
  })
}

export function getSFJParamByCode(parameter) {
  return request({
    url: api.GetSFJParamByCode,
    method: 'get',
    params: parameter
  })
}

export function getFarmMonitorStatus(parameter) {
  return request({
    url: api.GetFarmMonitorStatus,
    method: 'get',
    params: parameter
  })
}

export function getFarmMonitorDeviceDetail(parameter) {
  return request({
    url: api.GetFarmMonitorDeviceDetail,
    method: 'get',
    params: parameter
  })
}

export function analyze4GOfflineReason(parameter) {
  return request({
    url: api.Analyze4GOfflineReason,
    method: 'get',
    params: parameter
  })
}

export function refreshFarmMonitorStatus(parameter) {
  return request({
    url: api.RefreshFarmMonitorStatus,
    method: 'get',
    params: parameter
  })
}

export function getLand(parameter) {
  return request({ url: api.GetLand, method: 'get', params: parameter })
}

export function yieldFindAll(parameter) {
  return request({ url: api.YieldFindAll, method: 'get', params: parameter })
}

export function fertilizerFindAll(parameter) {
  return request({ url: api.FertilizerFindAll, method: 'get', params: parameter })
}

export function createLandScheme(parameter) {
  return request({ url: api.CreateLandScheme, method: 'get', params: parameter })
}

export function updateBase(parameter) {
  return request({ url: api.UpdateBase, method: 'get', params: parameter })
}

export function updateTopdressing(parameter) {
  return request({ url: api.UpdateTopdressing, method: 'get', params: parameter })
}

export function wfschemeSave() {
  return request({ url: api.WfschemeSave, method: 'post' })
}

export function getMapFarm(parameter) {
  return request({ url: api.GetMapFarm, method: 'get', params: parameter })
}

export function getMapFarmInfo(parameter) {
  return request({ url: api.GetMapFarmInfo, method: 'get', params: parameter })
}

export function getMapDeviceNum(parameter) {
  return request({ url: api.GetMapDeviceNum, method: 'get', params: parameter })
}

export function getProjectIrrigation(parameter) {
  return request({
    url: api.GetProjectIrrigation,
    method: 'get',
    params: parameter
  })
}

export function getDeviceInfo(parameter) { return request({ url: api.GetDeviceInfo, method: 'get', params: parameter }) }
export function getCDZDeviceInfo(parameter) { return request({ url: api.GetCDZDeviceInfo, method: 'get', params: parameter }) }
export function getMoisture(parameter) { return request({ url: api.GetMoisture, method: 'get', params: parameter }) }
export function getWeatherStationYL(parameter) { return request({ url: api.GetWeatherStationYL, method: 'get', params: parameter }) }
export function getCQInfo(deviceName) { return request({ url: api.GetCQInfo + deviceName, method: 'get' }) }
export function getBZInfo(deviceName) { return request({ url: api.GetBZInfo + deviceName, method: 'get' }) }
export function getSCDInfo(deviceName) { return request({ url: api.GetSCDInfo + deviceName, method: 'get' }) }
export function getSFJInfo(parameter) { return request({ url: api.GetSFJInfo, method: 'get', params: parameter }) }
export function getUsers(parameter) { return request({ url: api.GetUsers, method: 'get', params: parameter }) }
export function addUser(data) { return request({ url: api.AddUser, method: 'post', data }) }
export function authorizeUser(data) { return request({ url: api.AuthZUser, method: 'post', data }) }
export function removeUser(id) { return request({ url: api.RemoveUser + '/' + id, method: 'post' }) }
export function getFarmTree(parameter) { return request({ url: api.GetFarmTree, method: 'get', params: parameter }) }
export function getFarmById(parameter) { return request({ url: api.GetFarmById, method: 'get', params: parameter }) }
export function getGWs(parameter) { return request({ url: api.GetGWs, method: 'get', params: parameter }) }
export function getSoilMoistureLists(parameter) { return request({ url: api.GetSoilMoistureLists, method: 'get', params: parameter }) }
export function getWeatherStationLists(parameter) { return request({ url: api.GetWeatherStationLists, method: 'get', params: parameter }) }
export function getSporeDevices(parameter) { return request({ url: api.GetSporeDevices, method: 'get', params: parameter }) }
export function getInsecticidalLamps(parameter) { return request({ url: api.GetInsecticidalLamps, method: 'get', params: parameter }) }
export function getMonitors(parameter) { return request({ url: api.GetMonitors, method: 'get', params: parameter }) }
export function getPestMonitorPictures(parameter) { return request({ url: api.GetPestMonitorPictures, method: 'get', params: parameter }) }
export function getSFJs(parameter) { return request({ url: api.GetSFJs, method: 'get', params: parameter }) }
